/**
 * @file Schedule/constants.js
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

export const FULL_SCHEDULES_LINK = "/sports/streaming-schedule";
